module.exports = __webpack_public_path__ + "static/media/street-glide-special-metallic.c77051a1.png";